// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import dogWoman from './images/woman.svg'
import './styles.scss'

export class Section6 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section six' style={{colorScheme: this.props.colorMode === 'dark' ? 'dark' : 'light'}}>
      <div className="wrapper">
        <h2>Woher die meisten Hunde kommen</h2>
        <div className='two-column'>
            <div className={'column left'} key={'left'}>
              <div className='txt'>
                <p>
                  Gut 5 Prozent der Bevölkerung sind offiziell Halterin oder Halter. Das heisst, jede 20. Person in der Schweiz hat mindestens einen Hund. Gefühlt sind es deutlich mehr, weil sich meist alle im entsprechenden Haushalt als Besitzerin oder Besitzer fühlen. Auffällig ist, dass fast zwei Drittel der Halterinnen weiblich sind. Auch bei den Tieren ist das weibliche Geschlecht in der Mehrheit.
                </p>
                <p>
                  Müsste man die typische Schweizer Hundehalterin beschreiben, sähe sie also so aus: eine in Genf wohnhafte Frau, die eine Hündin der Rasse Chihuahua und mit dem Namen Luna besitzt.
                </p>
                <img src={dogWoman} alt='woman' />
                <p>
                  Die Hündin wurde aus Deutschland importiert, weil die Nachfrage in der Schweiz viel grösser ist als das Angebot aus hiesiger Zucht. In den letzten sieben Jahren wurden gut 214’000 Tiere aus dem Ausland angeschafft, die meisten aus unseren Nachbarländern, viele auch aus Osteuropa.
                </p>
              </div>
            </div>

            <div className={'column right'} key={'right'}>
              <div className="chart">
                <AutofitIFrame
                  src={'https://datawrapper.dwcdn.net/PTmwK/' + '?transparent=true' + '&dark=' + String(this.props.colorMode === 'dark')}
                />
              </div>
            </div>
        </div>
      </div>
    </div>
  }
}
